module.exports = __webpack_public_path__ + "static/media/Page13.b13eedf2.png";